import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { ErrorDisplayService } from '../../services/error-display.service';
import * as ErrorActions from '../actions/error.actions';

@Injectable()
export class ErrorEffects {
  private readonly actions$ = inject(Actions);
  private readonly errorDisplayService = inject(ErrorDisplayService);

  displayError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ErrorActions.displayGlobalError),
        tap(({ error }) => {
          this.errorDisplayService.showError(error);
        }),
      ),
    { dispatch: false }, // This effect does not dispatch new actions
  );
}
